import { render, staticRenderFns } from "./EngagementTaskDocuments.vue?vue&type=template&id=56bdf860&"
import script from "./EngagementTaskDocuments.vue?vue&type=script&lang=js&"
export * from "./EngagementTaskDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports